import { render } from "./Pascoa25.vue?vue&type=template&id=5760eae2&scoped=true"
import script from "./Pascoa25.vue?vue&type=script&lang=js"
export * from "./Pascoa25.vue?vue&type=script&lang=js"

import "./Pascoa25.vue?vue&type=style&index=0&id=5760eae2&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\natan\\OneDrive\\Code\\Site\\dalena\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5760eae2"]])

export default __exports__